function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient",
  x1: 434.34,
  y1: 353.64,
  x2: 512.69,
  y2: 353.64,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#545588"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7b7ca3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient-2",
  x1: 475.13,
  y1: 321.64,
  x2: 482.78,
  y2: 605.93,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff1e7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffe5d1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient-3",
  x1: 281.39,
  y1: 352.37,
  x2: 358.2,
  y2: 352.37,
  xlinkHref: "#fansi-digital_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient-4",
  x1: 322.88,
  y1: 327.14,
  x2: 330.54,
  y2: 611.43,
  xlinkHref: "#fansi-digital_svg__linear-gradient-2"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient-5",
  x1: 395.88,
  y1: 364.78,
  x2: 396.88,
  y2: 356.77,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#595a8c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7677a0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient-6",
  x1: 391.76,
  y1: 357.48,
  x2: 401.78,
  y2: 339.44,
  xlinkHref: "#fansi-digital_svg__linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient-7",
  x1: 380.43,
  y1: 348.93,
  x2: 413.69,
  y2: 348.93,
  xlinkHref: "#fansi-digital_svg__linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient-8",
  x1: 392.71,
  y1: 352.55,
  x2: 402.61,
  y2: 333.51,
  xlinkHref: "#fansi-digital_svg__linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient-9",
  x1: 378.94,
  y1: 343.32,
  x2: 415.16,
  y2: 343.32,
  xlinkHref: "#fansi-digital_svg__linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient-10",
  x1: 378.4,
  y1: 336.78,
  x2: 415.71,
  y2: 336.78,
  xlinkHref: "#fansi-digital_svg__linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient-11",
  x1: 396.13,
  y1: 333.96,
  x2: 399.8,
  y2: 316.76,
  xlinkHref: "#fansi-digital_svg__linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient-12",
  x1: 389.07,
  y1: 237.97,
  x2: 461.97,
  y2: 353.71,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffefe2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#fff0e4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#fff1e7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#ffebdc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#ffead9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffead9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient-13",
  x1: 375.76,
  y1: 327.09,
  x2: 390.62,
  y2: 283.67,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#9bb6ed"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient-14",
  x1: 389.97,
  y1: 331.95,
  x2: 404.83,
  y2: 288.53,
  xlinkHref: "#fansi-digital_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient-15",
  x1: 370.58,
  y1: 325.32,
  x2: 385.44,
  y2: 281.89,
  xlinkHref: "#fansi-digital_svg__linear-gradient-13"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient-16",
  x1: 391.63,
  y1: 211.89,
  x2: 377.1,
  y2: 331.64,
  xlinkHref: "#fansi-digital_svg__linear-gradient-12"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient-17",
  x1: 531.34,
  y1: 471.05,
  x2: 624.27,
  y2: 471.05,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#a87ff7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6165d5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fansi-digital_svg__linear-gradient-18",
  x1: -2449.69,
  y1: 572.13,
  x2: -2443.31,
  y2: 516.08,
  gradientTransform: "translate(3077.61)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fd8f83"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f96fb9"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "fansi-digital_svg__clippath"
}, /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-19",
  d: "M729.28 213.17c-2.9.26-5.67.56-8.21.8-7.86.77-25.08 5.53-31.01-2.29-9.79-12.91 15.08-34.79 21.34-44.63 7.74-12.16 17.34-25.71 18.9-40.48 2.37-22.47-13.02-52.86-32.02-64.59-26.2-16.18-62.8-5.17-86.33 10.72-34.1 23.02-58.06 60.98-67.78 100.64-10.48 42.74 3.97 86.98-.17 130.31-6.51 68.09-103.02-18.66-84.16 160.4C464 503.58 470.79 546.82 493 580.7c9.21 14.05 27.62 33.57 45.97 32.45 26.02-1.6 24.86-38.41 32.93-55.4 9.44-19.86 25.9-35.56 44.19-47.29 23.27-14.93 50.24-28.28 59.49-56.48 6.01-18.31-3.03-37.16-14.6-51.4-6.37-7.85-19.96-16.82-17.92-28.38 1.69-9.59 15.17-16.64 22.19-21.69 21.61-15.55 42.63-32.31 61.85-50.76 17.25-16.55 46.42-41.67 44.06-68.57-1.9-21.65-24.27-21.55-41.89-19.99z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "fansi-digital_svg__clippath-1"
}, /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-22",
  d: "M774.1 342.81c-9.1-32.81-37.93-57.66-70.9-66.23-20.08-5.22-44.59-6.99-65.07-3.42-28.8 5.01-52.58 23.8-71.11 45.58-21.77 25.59-23.81 57.3-31.6 88.79-1.53 6.17-11.59 40.18-19.21 20.25-10.63-27.79-34.33-22.89-34.34-22.89-18.55 3.84-32.8 17.45-39.66 34.59-18.32 45.78-12.65 105.24-8.78 153.23 1.82 22.57 4.63 45.02 7.98 67.4.83 5.53 4.8 10.07 10.18 11.62 5.38 1.55 11.16-.19 14.8-4.44 3.78-4.42 7.75-8.48 11.42-12.05 35.29-34.34 90.54-39.42 137.16-41.48 27.22-1.2 49.65-2.93 73.36-17.55 9.85-6.07 20.56-13.53 25.13-24.63 4.13-10.04 4.94-27.23-1.29-36.57-7.75-11.63-24.97-10.9-35.22-19.46-16.56-13.84 26.75-23.47 35.47-26.28 13.91-4.47 23.13-15.56 33.55-25.18 7.96-7.35 15.44-15.34 21.22-24.55 17.64-28.11 15.48-65.85 6.91-96.73z"
})), /*#__PURE__*/React.createElement("style", null, ".fansi-digital_svg__cls-12{fill:#545588}.fansi-digital_svg__cls-13{fill:#fff}.fansi-digital_svg__cls-19{fill:#887dde}.fansi-digital_svg__cls-22{fill:#e39fb7}.fansi-digital_svg__cls-23{fill:#89d1c7}.fansi-digital_svg__cls-25{opacity:.8;mix-blend-mode:soft-light;fill:none}.fansi-digital_svg__cls-33{fill:#ffe5d1}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-13",
  d: "M-1451.9-9148.37h9446.2V1127.72h-9446.2z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M769.93 352.41C751.1 229.18 673.92 77.79 521.42 61.95c0 0-115.78-14.08-229.91 7.26-67.74 12.67-127.14 50.38-164.72 104.57-37.58 54.2-50.14 120.28-34.9 183.29 9.9 40.92 16.58 83.28 14.75 125.32-3.19 73.18-1.36 141.5 69.67 185.14 63.42 38.97 143.23 73.34 219.36 79.36 51.74 4.09 109.77-2.53 159.64-16 254.16-68.66 233.45-255.26 214.62-378.48z",
  fill: "#f3f5f8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-19",
  d: "M729.28 213.17c-2.9.26-5.67.56-8.21.8-7.86.77-25.08 5.53-31.01-2.29-9.79-12.91 15.08-34.79 21.34-44.63 7.74-12.16 17.34-25.71 18.9-40.48 2.37-22.47-13.02-52.86-32.02-64.59-26.2-16.18-62.8-5.17-86.33 10.72-34.1 23.02-58.06 60.98-67.78 100.64-10.48 42.74 3.97 86.98-.17 130.31-6.51 68.09-103.02-18.66-84.16 160.4C464 503.58 470.79 546.82 493 580.7c9.21 14.05 27.62 33.57 45.97 32.45 26.02-1.6 24.86-38.41 32.93-55.4 9.44-19.86 25.9-35.56 44.19-47.29 23.27-14.93 50.24-28.28 59.49-56.48 6.01-18.31-3.03-37.16-14.6-51.4-6.37-7.85-19.96-16.82-17.92-28.38 1.69-9.59 15.17-16.64 22.19-21.69 21.61-15.55 42.63-32.31 61.85-50.76 17.25-16.55 46.42-41.67 44.06-68.57-1.9-21.65-24.27-21.55-41.89-19.99z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "fansi-digital_svg__cls-25",
  clipPath: "url(#fansi-digital_svg__clippath)"
}, /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-13",
  d: "M590.61 659.91c-.27 0-.53-.08-.77-.25-44.41-31.72-65.31-80.16-63.9-148.07 1.23-59.21 18.59-123.45 35.37-185.58 13.22-48.93 25.7-95.14 27.97-132.26 1.82-29.74 10.31-56.71 25.24-80.18 11.94-18.76 27.99-35.32 47.71-49.22 33.54-23.64 66.58-31.49 66.91-31.56.71-.17 1.42.28 1.58.99.16.71-.28 1.42-.99 1.58-.33.08-32.94 7.83-66.06 31.2-30.5 21.51-67.7 61.07-71.76 127.35-2.29 37.39-14.81 83.72-28.06 132.78-33.03 122.26-70.46 260.83 27.51 330.81.59.42.73 1.25.31 1.84-.26.36-.66.55-1.08.55z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-13",
  d: "M591.66 183.71c-.13 0-.27-.02-.41-.06-.36-.11-8.81-2.93-18.06-13.93-8.43-10.03-19.16-29.11-22.38-63.1a1.322 1.322 0 012.63-.25c3.14 33.17 13.49 51.74 21.62 61.48 8.77 10.51 16.91 13.26 16.99 13.29.69.23 1.07.97.85 1.66-.18.56-.7.91-1.25.91zM578.46 266.7a1.323 1.323 0 01-.13-2.64c.23-.02 22.88-2.46 52.57-15.56 27.37-12.08 66.5-35.96 97.48-81.14.41-.6 1.23-.76 1.84-.34.6.41.75 1.23.34 1.84-31.35 45.73-70.97 69.89-98.69 82.1-30.05 13.24-53.04 15.7-53.27 15.73h-.14zM530.8 469.18c-.15 0-.29-.02-.44-.08-.92-.32-22.73-8.19-40.75-30.24-10.59-12.95-17.59-28.11-20.83-45.05-4.03-21.11-2.18-45.05 5.51-71.15.21-.7.94-1.1 1.64-.89.7.21 1.1.94.89 1.64-17.1 58.04-1.41 93.86 14.75 113.69 17.54 21.52 39.44 29.44 39.66 29.51.69.24 1.05 1 .81 1.68-.19.54-.7.88-1.24.88zM538.48 424.61c-.65 0-1.22-.48-1.31-1.15-.1-.72.41-1.39 1.14-1.48 1.06-.14 105.88-14.38 131.56-54.04a1.323 1.323 0 112.22 1.44c-11.09 17.13-36.95 31.63-76.86 43.11-29.59 8.51-56.31 12.08-56.57 12.12-.06 0-.12.01-.17.01z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-22",
  d: "M774.1 342.81c-9.1-32.81-37.93-57.66-70.9-66.23-20.08-5.22-44.59-6.99-65.07-3.42-28.8 5.01-52.58 23.8-71.11 45.58-21.77 25.59-23.81 57.3-31.6 88.79-1.53 6.17-11.59 40.18-19.21 20.25-10.63-27.79-34.33-22.89-34.34-22.89-18.55 3.84-32.8 17.45-39.66 34.59-18.32 45.78-12.65 105.24-8.78 153.23 1.82 22.57 4.63 45.02 7.98 67.4.83 5.53 4.8 10.07 10.18 11.62 5.38 1.55 11.16-.19 14.8-4.44 3.78-4.42 7.75-8.48 11.42-12.05 35.29-34.34 90.54-39.42 137.16-41.48 27.22-1.2 49.65-2.93 73.36-17.55 9.85-6.07 20.56-13.53 25.13-24.63 4.13-10.04 4.94-27.23-1.29-36.57-7.75-11.63-24.97-10.9-35.22-19.46-16.56-13.84 26.75-23.47 35.47-26.28 13.91-4.47 23.13-15.56 33.55-25.18 7.96-7.35 15.44-15.34 21.22-24.55 17.64-28.11 15.48-65.85 6.91-96.73z"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  className: "fansi-digital_svg__cls-25",
  clipPath: "url(#fansi-digital_svg__clippath-1)"
}, /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-13",
  d: "M435.95 683.5c-.19 0-.38-.04-.56-.13-.66-.31-.94-1.1-.63-1.76.43-.92 44.13-93.24 104.43-187.87 35.43-55.6 69.59-101.12 101.52-135.28 40.04-42.84 76.72-67.89 109.04-74.47.72-.15 1.41.32 1.56 1.03.15.71-.32 1.41-1.03 1.56-31.77 6.47-67.98 31.26-107.64 73.68-31.82 34.05-65.88 79.43-101.22 134.9-60.21 94.48-103.83 186.65-104.27 187.58-.23.48-.7.76-1.2.76z"
}), /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-13",
  d: "M592.98 419.3c-.07 0-.14 0-.21-.02-.72-.12-1.21-.79-1.1-1.51.2-1.25 19.65-124.75.34-145.59-.5-.53-.46-1.37.07-1.87s1.37-.46 1.87.07c20.19 21.78 1.16 142.67.34 147.8-.1.65-.66 1.11-1.3 1.11zM823.86 355.36c-.24 0-.48-.06-.7-.2-51.79-32.37-159.54-15.47-160.62-15.29-.72.12-1.4-.37-1.51-1.09-.12-.72.37-1.4 1.09-1.51.27-.04 27.67-4.4 61.16-4.66 30.99-.24 73.73 3.1 101.28 20.32.62.39.81 1.2.42 1.82-.25.4-.68.62-1.12.62zM479.42 599.18c-.1 0-.2-.01-.3-.03-.71-.16-1.15-.87-.99-1.58 14.14-61.09-38.87-150.15-39.41-151.04-.38-.63-.17-1.44.45-1.81.63-.38 1.44-.17 1.81.45.14.23 13.69 22.87 25.29 52.85 10.73 27.74 21.95 67.64 14.43 100.15-.14.61-.68 1.02-1.29 1.02zM523.24 523.17a1.325 1.325 0 01-.41-2.58c.47-.16 48.02-15.75 105.61-27.05 53.25-10.45 126.23-19.25 171.53-1.85a1.323 1.323 0 11-.95 2.47c-44.72-17.17-117.18-8.4-170.08 1.98-57.42 11.27-104.82 26.81-105.29 26.96-.14.05-.28.07-.41.07z"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M611.24 110.79L177.08 86.24c-6.74-.29-22.8 7.17-22.02 17.72v593.5c0 7.21 5.48 12.63 12.22 12.11l443.95-34.1c5.61-.43 10.15-6.09 10.15-12.64V123.09c0-6.55-4.54-12.06-10.15-12.31z",
  fill: "#bdc6d4"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M622.25 105.3L177.08 86.24c-6.76-.29-12.25 5.32-12.25 12.54v594.29c0 7.22 5.49 12.64 12.25 12.12l445.17-34.41c5.63-.44 10.18-6.11 10.18-12.67v-540.5c0-6.56-4.55-12.08-10.18-12.32z",
  fill: "#d6dce6"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-13",
  d: "M398.65 116.58c0 5.32 3.86 9.78 8.62 9.96 4.75.18 8.59-3.97 8.59-9.26s-3.84-9.76-8.59-9.96c-4.76-.2-8.62 3.95-8.62 9.26z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M203.11 666.31l392.67-26.93c3.92-.27 7.09-4.17 7.09-8.72V151.27c0-4.55-3.17-8.35-7.09-8.49l-392.67-14.32c-4.6-.17-8.34 3.7-8.34 8.64v520.83c0 4.94 3.74 8.69 8.34 8.37z",
  opacity: 0.4,
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-23",
  d: "M260.1 663.16l24.62-164.92c4.25-28.47-4.16-57.1-22.74-77.17-10.33-11.16-16.86-25.91-18.32-41.82-2.28-24.84-2.01-65.43 13.01-114.86 19.86-65.36 79.35-103.8 139.83-92.39 29.55 5.57 63.54 16.72 98.77 37.74 20.03 11.95 33.68 34.37 35.83 59.76 1 11.8 2.85 24.88 6.22 36.49 4.23 14.6 6.06 24.59 6.82 31.07.69 5.88-1.31 11.77-5.23 15.66-4.04 4.02-5.05 10.76-2.39 16.04l29.34 58.23v1.89c0 5.86-3.93 10.81-9 11.34l-17.74 1.83.67 20.91c.13 4.04-2.18 7.73-5.58 8.9l-4.08 1.41 3.72 3.29c3.02 2.68 3.82 7.55 1.87 11.46l-5.25 10.53c-2.38 4.77-2.04 10.63.86 14.79 4.79 6.87 5.77 16.36 2.54 24.66l-1.47 3.77c-6.8 17.49-23.03 27.97-39.34 25.22-18.62-3.14-42.7-8.42-59.38-16.53-4.76-2.31-10.26 1.91-10.26 7.85v93.6l-163.31 11.25z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M512.54 313.54l-2.61-2.41c-2.99-2.78-4.6-3.19-7.02-1.76-1.27.75-2.2 1.96-2.6 3.37l-6.17 21.81c-.85 3-2.45 5.73-4.65 7.93l-1.05 1.05c-1.48 1.48-3.2 2.69-5.1 3.59L463 356.74l16.88-14.31c1.64-1.87-2.21-5.5-4.08-7.15l-.51-.45a4.514 4.514 0 00-5.59-.3c-6.07 4.28-19.98 14.14-25.77 18.74-5.57 4.42-8.38 20.49-9.47 28.5-.4 2.93.08 5.88 1.39 8.54 1.49 3.02 6.05 8.02 9.4 8.4l.26-2.73c3.53.4 7.09-.39 10.12-2.25l38.42-23.58c4.92-3.02 8.33-7.99 9.37-13.67l7.5-40.91c.25-1.38 2.34-.83 1.61-2.03z",
  fill: "url(#fansi-digital_svg__linear-gradient)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M513.47 314.84l-.26-.43a5.155 5.155 0 00-7.02-1.76c-1.27.75-2.2 1.96-2.6 3.37l-6.17 21.81c-.85 3-2.45 5.73-4.65 7.93l-1.05 1.05c-1.48 1.48-3.2 2.69-5.1 3.59l-20.34 9.62 13.21-15.1a4.518 4.518 0 00-.41-6.36l-.51-.45a4.514 4.514 0 00-5.59-.3c-6.07 4.28-19.98 14.14-25.77 18.74-5.57 4.42-8.38 20.49-9.47 28.5-.4 2.93.08 5.88 1.39 8.54a9.887 9.887 0 007.76 5.45l1.89.22c3.53.4 7.09-.39 10.12-2.25l38.42-23.58c4.92-3.02 8.33-7.99 9.37-13.67l7.5-40.91a5.75 5.75 0 00-.74-4.01z",
  fill: "url(#fansi-digital_svg__linear-gradient-2)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M282.23 311.56l.26-.43a5.155 5.155 0 017.02-1.76c1.27.75 5.29 4.68 5.69 6.09l3.08 19.09c.85 3 2.45 5.73 4.65 7.93l1.05 1.05c1.48 1.48 3.2 2.69 5.1 3.59l20.34 9.62-13.21-15.1a4.518 4.518 0 01.41-6.36l.51-.45a4.514 4.514 0 015.59-.3c6.07 4.28 19.98 14.14 25.77 18.74 5.57 4.42 8.52 9.85 9.6 17.87.4 2.93-.22 16.52-1.53 19.17a9.887 9.887 0 01-7.76 5.45l-1.89.22c-3.53.4-7.09-.39-10.12-2.25l-38.42-23.58a20.344 20.344 0 01-9.37-13.67l-7.5-40.91a5.75 5.75 0 01.74-4.01z",
  fill: "url(#fansi-digital_svg__linear-gradient-3)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M286.05 314.84l.26-.43a5.155 5.155 0 017.02-1.76c1.27.75 2.2 1.96 2.6 3.37l6.17 21.81c.85 3 2.45 5.73 4.65 7.93l1.05 1.05c1.48 1.48 3.2 2.69 5.1 3.59l20.34 9.62-13.21-15.1a4.518 4.518 0 01.41-6.36l.51-.45a4.514 4.514 0 015.59-.3c6.07 4.28 19.98 14.14 25.77 18.74 5.57 4.42 8.38 20.49 9.47 28.5.4 2.93-.08 5.88-1.39 8.54a9.887 9.887 0 01-7.76 5.45l-1.89.22c-3.53.4-7.09-.39-10.12-2.25l-38.42-23.58a20.344 20.344 0 01-9.37-13.67l-7.5-40.91a5.75 5.75 0 01.74-4.01z",
  fill: "url(#fansi-digital_svg__linear-gradient-4)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M453.48 249.16c0-29.67-25.26-53.73-56.42-53.73s-56.42 24.05-56.42 53.73c0 18.01 9.3 33.94 23.59 43.69 6.06 4.14 9.73 10.95 9.73 18.29v4.11c0 8.93 7.24 16.17 16.17 16.17h13.86c8.93 0 16.17-7.24 16.17-16.17v-4.11c0-7.34 3.67-14.15 9.73-18.29 14.28-9.75 23.59-25.69 23.59-43.69z",
  fill: "#cad8f5",
  opacity: 0.75
});

var _ref18 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 397.06,
  cy: 355.38,
  rx: 12.52,
  ry: 6.63,
  fill: "url(#fansi-digital_svg__linear-gradient-5)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M380.43 343.54v6.77c0 2.29 1.3 4.39 3.37 5.37 2.87 1.37 7.64 2.87 14.57 2.69 5.62-.14 9.29-1.06 11.62-2.03 2.25-.93 3.7-3.16 3.7-5.6V347l-33.26-3.46z",
  fill: "url(#fansi-digital_svg__linear-gradient-6)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M381.9 338.94c-1.87-.2-3.5 1.27-3.5 3.16v.19c0 2.57 1.46 4.92 3.78 6.03 3.22 1.53 24.3 4.96 29.39 3.05 2.56-.96 4.15-3.16 4.15-5.89v-.15c0-1.63-1.23-2.99-2.85-3.16l-30.96-3.22z",
  fill: "url(#fansi-digital_svg__linear-gradient-8)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M380.69 327.97a2.29 2.29 0 00-2.29 2.29v5.3c0 2.57 1.46 4.92 3.78 6.03 3.22 1.53 25.2 5.41 29.39 3.44 2.47-1.17 4.15-3.54 4.15-6.28v-8.49a2.29 2.29 0 00-2.29-2.29H380.7z",
  fill: "url(#fansi-digital_svg__linear-gradient-10)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M415.25 329.62c0 2.38-8.15 4.3-18.19 4.3s-18.19-1.93-18.19-4.3 8.15-4.3 18.19-4.3 18.19 1.93 18.19 4.3z",
  fill: "url(#fansi-digital_svg__linear-gradient-11)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M453.48 249.16c0-29.67-25.26-53.73-56.42-53.73s-56.42 24.05-56.42 53.73c0 18.01 9.3 33.94 23.59 43.69 6.06 4.14 9.73 10.95 9.73 18.29v4.11c0 8.93 7.24 16.17 16.17 16.17h13.86c8.93 0 16.17-7.24 16.17-16.17v-4.11c0-7.34 3.67-14.15 9.73-18.29 14.28-9.75 23.59-25.69 23.59-43.69z",
  fill: "url(#fansi-digital_svg__linear-gradient-12)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M393.59 328.16c-.38 0-.71-.28-.76-.67l-9.79-76.17c-.05-.42.24-.81.67-.86.42-.06.81.24.86.66l9.79 76.17c.05.42-.24.81-.67.86h-.1z",
  fill: "url(#fansi-digital_svg__linear-gradient-13)"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M399.67 328.16h-.1a.774.774 0 01-.67-.86l9.79-76.17a.76.76 0 01.86-.66c.42.05.72.44.67.86l-9.79 76.17c-.05.39-.38.67-.76.67z",
  fill: "url(#fansi-digital_svg__linear-gradient-14)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M407.65 251.25c-.25 0-.5-.12-.64-.35l-2.7-4.1s-.07-.07-.11-.06c-.07 0-.1.05-.1.06l-1.78 2.99c-.3.5-.81.8-1.39.81-.57.02-1.11-.26-1.43-.75l-2.45-3.67s-.06-.06-.11-.06-.08.02-.1.06l-2.15 3.11c-.31.45-.82.72-1.36.72-.54 0-1.05-.27-1.37-.72l-3.1-4.45s-.07-.05-.11-.06c-.04 0-.08.02-.1.07l-2.83 4.89c-.21.37-.68.49-1.05.28a.767.767 0 01-.28-1.05l2.83-4.89c.29-.5.8-.81 1.37-.83.57-.03 1.11.24 1.44.71l3.1 4.45s.06.06.1.06.08-.02.1-.06l2.15-3.11c.32-.45.83-.73 1.38-.72.55 0 1.06.28 1.37.75l2.45 3.67s.07.08.11.06c.07 0 .09-.05.1-.06l1.78-2.99c.3-.5.82-.8 1.39-.81.57-.01 1.11.27 1.43.75l2.7 4.1a.775.775 0 01-.64 1.2z",
  fill: "url(#fansi-digital_svg__linear-gradient-15)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-13",
  d: "M402.64 180.61c0 2.09-2.16 4.9-4.29 4.9h-.02c-2.13 0-3.36-2.96-3.36-5.05v-38.03c0-2.09 1.23-2.9 3.36-2.9h.02c2.13 0 4.29.94 4.29 3.04v38.04zM355.09 186.24c.99 1.95.28 4.33-1.6 5.32h-.02c-1.87.99-4.2.21-5.19-1.74l-18-35.43c-.99-1.95-.28-4.33 1.6-5.32h.02c1.87-1 4.19-.22 5.19 1.74l18 35.44zM326.57 209.72c1.89 1.02 2.66 3.41 1.71 5.35v.02c-.96 1.93-3.26 2.68-5.16 1.66l-34.35-18.46c-1.89-1.02-2.65-3.41-1.71-5.34v-.02c.96-1.93 3.26-2.68 5.15-1.66l34.36 18.46zM316.05 243.67c2.12.08 4.84 1.93 3.99 4.09v.02c0 2.18-1.99 3.89-4.11 3.82l-38.25-1.4c-2.11-.08-4.47-1.92-3.62-4.08v-.02c0-2.18 1.62-3.89 3.73-3.82l38.25 1.39zM433.36 187.76c-1 1.92-.28 4.33 1.61 5.39h.02c1.88 1.07 4.22.38 5.21-1.54l18.1-34.84c1-1.92.28-4.34-1.61-5.4h-.02c-1.88-1.07-4.22-.37-5.22 1.55l-18.09 34.84zM462.04 212.44c-1.91.94-2.68 3.31-1.72 5.29v.02c.96 1.98 3.28 2.82 5.19 1.87l34.66-17.16c1.91-.95 2.68-3.32 1.72-5.3v-.02c-.97-1.98-3.29-2.82-5.2-1.87l-34.65 17.17zM472.86 246.96c-2.13-.01-4.65 1.74-3.8 3.95v.02c0 2.19 1.78 3.98 3.92 3.99l38.52.22c2.14.01 4.4-1.74 3.55-3.96v-.02c0-2.2-1.52-3.98-3.66-3.99l-38.52-.21z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-33",
  d: "M528.75 461.26s-1.88-7.39-5.02-9.34c-3.14-1.95-7.57-4.04-8.58-4.89-1.02-.86-2.2 1.7.72 3.66l2.93 1.96c.06.54-.02.96-.12 1.26-.46 1.39-2.04 2.34-4 2.52-7.51 1.57-10.44 1.65-11.58 1.31-.17-.05-.82-.26-1.1.03-.44.47.35 1.94.69 2.46 2.03 3.1 9.08 4.45 14.36 2.03 1.93-.89 2.67-1.84 4.07-1.6 2.23.38 3.61 3.33 4.42 5.77l3.21-5.16z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-13",
  d: "M624.27 439.75c-.47 8.16-2.16 16.68-5.39 24.57-2.17 5.32-14.15 34.59-41.33 37.77-16.9 1.97-34.59-6.75-46.22-22.56-3.48-4.71-6.42-10.05-8.64-15.92 2.13-1.89 4.27-3.79 6.41-5.7.78.79 12.19 11.93 28.14 8.55 10.99-2.32 17.32-11.34 21.38-17.09 12.18-17.3 4.89-29.98 18.02-41.73 3.64-3.27 10.79-7.22 15.47-6.01 7.8 2.01 13.28 19.05 12.16 38.13z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-12",
  d: "M673.15 743.91c1.17.95 1.39 3.33 1.53 4.89.06.69.09 1.04.02 1.29-.57 1.79-4.04 1.98-9.48 2.53-8.6.88-11.16 1.56-11.83.28-.63-1.2.9-3.16 1.07-3.38.92-1.16 2.06-1.59 4.25-2.31 4.06-1.34 6.8-2.07 7.63-2.29 5.18-1.38 6.05-1.63 6.82-1.01z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-33",
  d: "M668.04 736.05l-.86 9.8c.24.47 3.16 1.89 5.47.68l2.21-9.63-6.82-.84z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-12",
  d: "M597.99 739.57c1.4 1.55 1.72 4.41.5 5.81-1.2 1.38-3.01.35-8.12.5-5.48.16-6.91 1.46-10.64.43-1.51-.42-4.16-1.43-4.11-2.5.04-.76 1.39-1.15 5.91-2.66 6.42-2.15 6.39-2.27 7.75-2.49 3.42-.57 6.86-1.14 8.71.91z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-33",
  d: "M594.47 730.63l-2.75 9.15c.21.49 3 2.13 5.4 1.09l4.08-8.88-6.74-1.36z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-23",
  d: "M618.91 530.29a854.83 854.83 0 01-7.53 102.86 856.739 856.739 0 01-19.55 100.14c3.51.94 7.02 1.89 10.53 2.83 8.9-8.3 20.13-21.37 25.55-39.83 3.36-11.46 2.24-17.35 4.37-31.44 3.4-22.44 10.28-34.2 17.39-52.3 6.39-16.26 13.94-40.13 17.99-72.03l-48.75-10.23z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-23",
  d: "M657.55 530.43a5462.66 5462.66 0 017.48 209.54c3.58.44 7.17.89 10.75 1.33 3.46-6.45 8.06-16.3 11.21-28.94 3.83-15.34 2.94-24.46 4.62-40.36 1.88-17.84 4.62-21.72 9.46-44.22 9.83-45.67 14.75-68.5 3.78-82.7-3.56-4.61-14.72-16.18-47.31-14.63z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-19",
  d: "M700.31 401.41c-8.39-2.36-20.69-5.12-35.76-5.97-21.49-1.21-32.23-1.82-39.84 3.29-17.58 11.82-3.97 39.09-11.17 106.7-3.06 28.74-4.44 26.88 2.46 37.11 14.01 20.78 53.35 22.48 71.37 4.47 9.53-9.52 10.75-10.06 10.98-20.92.9-42.89 1.59-83.38 1.96-124.67z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-13",
  d: "M607.65 402.05c11.17-5.74 21.54-6.79 27.41-6.94 5.32 13.13 12 32.93 15.15 57.7 2.85 22.35 1.52 37.15 0 67.86-.96 19.4-1.95 47.51-1.65 82.14-5.92 1.9-10.75 2.34-14 2.42-11.5.26-15.34-3.9-27.09-2.75-5.12.5-6.4 1.49-8.12.34-4.81-3.2-1.21-15.08 1.2-27.99 3.73-19.95-.33-15.84 3.31-48.15 3.02-26.78 7.18-41.79 3.31-43.33-2.08-.83-4.04-78.97.48-81.3z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-13",
  d: "M660.73 456.57c-2.63 9.99-2.39 17.94-2.11 25.28 1.55 40.42 2.33 60.75 3.01 66.5 3.29 27.95 5.61 26.21 4.81 37.56-.43 6.08-1.42 11.28 1.9 15.1 3.96 4.56 9.67 2.09 23.7 3.9 12.9 1.66 13.24 4.41 27.18 6.09 5.66.68 21.13 2.54 22.75-1.86.86-2.35-2.34-6.22-5.42-8.12-5.02-3.11-9.3-.77-11-3.25-1.94-2.84 3.3-6.48 3.47-13.3.17-6.8-4.9-9.02-8.04-17.37-2.93-7.78-1.75-14.41-1.3-19.1 2.02-20.94-7.2-37.5-9.02-65.24-2.83-43.2 15.64-62.17 3.1-76.01-6.79-7.49-17.96-8.29-24.95-8.12-7.26 15.12-13.51 27.02-17.93 35.19-4.78 8.82-7.91 14.19-10.17 22.77zM632.6 445.43c1.03-3.55 4.29-6.95 3.01-11.13-.75-2.47-2.73-4.06-4.25-5.02-10.02-2.25-16.76-11.62-15.76-21.46.4-3.95 2.02-7.59 4.48-10.54a64.2 64.2 0 0114.98-2.16c5.32 13.13 12 32.93 15.15 57.7 1.34 10.55 1.75 19.42 1.65 29.07-1.74-5.54-4.17-9.68-6.76-12.83-4.38-5.32-15.02-14.97-12.51-23.61z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-13",
  d: "M690.22 433.24c-5.7 5.06-9.82 6.77-10.53 11.61-.78 5.32 3.65 7.1 2.9 12.28-.94 6.48-8.29 6.5-12.07 14.78-2.48 5.42-.32 7.58-1.81 14.59-.91 4.28-3.15 10.24-9.25 16.86-.25-6.43-.52-13.58-.83-21.52-.28-7.34-.52-15.29 2.11-25.28 2.26-8.58 5.39-13.94 10.17-22.77 4.43-8.17 10.68-20.07 17.93-35.19 4.09-.1 9.62.14 14.87 1.86 1.81 3.3 2.11 5.93 2.16 7.34.41 11.16-11.84 22.05-15.65 25.43z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-33",
  d: "M662.94 371.96c-.05 6.37.66 11.42 1.33 14.88.77 3.96 1.33 4.99 2.03 5.82 1.07 1.25 2.68 2.3 11.81 4.56 4.97 1.23 5.61 1.2 5.72 1.69.54 2.4-13.01 10.6-27 8.62-8.56-1.21-16.36-6.09-15.88-8.66.48-2.58 9.04-1.2 11.59-5.87 1.77-3.25-.21-7.86-2.56-11.68 2.28-4.26 10.7-5.1 12.97-9.37z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-19",
  d: "M647.05 374.48c-2.02-2.68-2.15-7.37.18-10.33 2-2.55 5.16-2.91 7.05-3.13 5.47-.63 12.37 1.65 14.78 6.69 1.42 2.98-1.66 9.18-2.14 10.3-.55 1.26-1.54 1.69-2.45 2.65-1.27 1.32-3.25 3.42-6.5 6.94-.25-1.04-.63-2.32-1.24-3.71-.23-.54-1.17-2.63-2.6-4.36-2.85-3.48-5.16-2.49-7.08-5.03z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-33",
  d: "M662.59 384.63s-3.6 5.9-10.76 5.43c-6.41-.42-7.35-14.8-3.26-17.85 1.37-1.02 4.1-1.44 6.33-.82 1.31.37 1.76.91 3.92 1.47 1.99.52 2.55.3 3.15.8.75.63 1.3 2.18.05 6.39 1.22-1.24 2.69-1.71 3.73-1.22.17.08.61.38.85.83.9 1.64-.6 3.74-4.02 4.96z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-19",
  d: "M662.27 372.81c-.31.23.64 1.38.71 3.02.14 3.17-3.07 6.97-6.34 7.3-1.93.19-2.47-.98-5.67-1.31-1.98-.21-3.63.04-4.67.27-1.01 3.48-.06 6.94 2.26 8.55 2.5 1.73 5.7.68 7.03.24.89-.29 3.76-1.23 5.25-3.86 1.56-2.74.03-4.39 1.82-6.24.9-.93 2.09-1.34 3.24-3.15.31-.49.52-.93.65-1.22-1.65-1.75-3.84-3.94-4.29-3.6z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-13",
  d: "M685.59 464.9c-3.66 7.76 13.14 25.84 31.81 34.43 3.8 1.75 31.12 14.31 43.3 2.23 10.06-9.98 3.57-30.62 1.25-37.99-11.38-36.18-43.59-56.46-58.24-63.1-10.93 27.34-7.24 41.39-4.71 45.2 2.65 3.97 10.04 12.32 17.88 19.67 5.52 5.17 8.96 7.69 8.5 8.49-.58 1-7.05-.89-32.18-13.12-2.91.47-6.37 1.53-7.61 4.18z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-22",
  d: "M623.44 419.52l44.48 4.17c.93.09 1.72.74 1.97 1.64l16.6 57.97c.44 1.53-.8 3.03-2.39 2.89l-44.85-3.96c-.94-.08-1.74-.74-1.99-1.65l-16.24-58.18c-.43-1.54.82-3.02 2.4-2.88z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-33",
  d: "M691.94 463.08s-15.32-15.68-21.55-17.99c-6.23-2.32-.71 14.22 2.94 16.55s5.08 3.22 7.93 3.58l2.85.36 3.74 1.99s4.81-.57 4.1-4.49z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-33",
  d: "M298 412.97s-1.97-7.38-.57-9.26c1.39-1.89 9.92-9.43 9.1-6.97s-2.05 4.1-2.05 4.1 4.59 2.13 1.64 5.33-3.94 3.94-4.1 6.8c-.16 2.87-2.05 3.85-4.02 0z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-12",
  d: "M216.1 731.45s-1.04 6.38-.91 8.65c.13 2.27 25.33 3.43 25.59 1.73.25-1.7-4.17-4.41-7.28-5.36-3.11-.95-12.22-3.5-12.22-3.5l-5.19-1.52z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-33",
  d: "M222.22 725.09l-.8 7.93s-2.93 1.93-5.51.44l-1.29-8.64 7.6.26z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-12",
  d: "M171.13 741.8s-1.04 6.38-.91 8.65c.13 2.27 25.33 3.43 25.59 1.73.25-1.7-4.17-4.41-7.28-5.36-3.11-.95-12.22-3.5-12.22-3.5l-5.19-1.52z"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-33",
  d: "M177.25 735.44l-.8 7.93s-2.93 1.93-5.51.44l-1.29-8.64 7.6.26z"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-12",
  d: "M217.64 517.95c2.91 5.91 5.83 11.81 8.74 17.72 2.34 33.7 3.51 70.35 2.76 109.55-.56 29.16-2.11 56.78-4.35 82.71l-11.85-.54c-5.71-11.34-12.45-28.51-13.07-49.71-.65-22.11 6.06-25.05 5.63-46.22-.55-27.44-12.06-34.76-18.19-67.77-2.34-12.62-3.92-29.11-2.05-49.11 10.79 1.13 21.59 2.25 32.38 3.38z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-12",
  d: "M201.97 528.58c-5.47 29.82-10.3 61.73-14.07 95.58-4.55 40.87-6.98 79.39-7.93 115.16-4.34.12-8.67.25-13.01.37-17.08-33.79-18.13-56.71-15.66-71.62.95-5.75 3.53-17.02 4.12-33.87.41-11.74-.34-20.68-1.27-31.42-2.05-23.55-4.54-28.7-4.9-46.71-.34-16.91-.41-25.46 4.42-30.46 12.72-13.16 45.8 1.81 48.31 2.97z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-22",
  d: "M295.73 411.83l8.65-.6c6.8 27.48 1.92 54.15-13.43 63.95-23.98 15.32-68.56-13.54-78.21-44.97-4.24-13.79-3.27-33.7 5.2-37.57 2.35-1.07 6-1.24 13.91 3.2 23.61 13.26 24.24 38.32 36.24 40.44 5.34.94 13.96-2.46 27.65-24.45z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-22",
  d: "M229.7 541.71c4.15-6.89-1.06-13.54-2.25-26.6-1.35-14.8 4.36-17.26 9.99-41.79 3.75-16.31 7.35-31.97 3.05-50.3-2.06-8.78-5.55-23.68-17.88-30.88-6.36-3.71-15.05-3.34-32.17-2.45-21.17 1.11-31.75 1.66-39.64 5.82-1.16.61-25.17 13.67-26.82 34.96-1.68 21.67 21.92 24.58 25.06 53.48 1.41 12.97-1.11 32.92-2.74 45.86-1.57 12.43-2.65 15.61-.2 19.37 5.91 9.07 24 6.48 60.19 1.32 14.19-2.03 20.3-3.64 23.4-8.79z"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-33",
  d: "M136.83 521.93l5.99 3.82c1.08-1.24 3.56-3.75 7.45-4.6 4.38-.96 9.41.42 9.52 1.82.09 1.12-2.97 2.25-3.44 2.42-3.82 1.41-6.66.24-8.2 1.78-.55.54-1.23 1.55-2.79 2.49-.41.25-.84.46-1.07.55-2.55.99-6.93-3.45-7.3-3.84l-.16-4.44z"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-22",
  d: "M154.53 443.37c4.33-10.38 7.33-26.26.49-49.86-45.09 17.77-68.09 59.89-59.11 93.28 7.4 27.53 34.33 40.93 40.34 43.75 1.4-3.18 2.8-6.36 4.19-9.54-6.96-7.75-14.81-19.22-13.7-32.3 1.54-18.13 19.01-24.32 27.78-45.33z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-33",
  d: "M189.34 368.35s-.36 7.89-2.8 13.8c-2.21 5.34-13.85 8.69-16.21 9.89-2.36 1.19 4.42 4.67 11.23 5.36 6.81.68 26.25-.86 29.75-3.44s-2.82-2.39-7.68-4.17c-4.86-1.78-7.67-11.29-6.81-15.6.86-4.31-7.48-5.83-7.48-5.83z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-12",
  d: "M200.1 365.49c3.53-3.47 4.03-3.88 4.41-5.08 1.54-4.81-2.19-11.41-7.09-13.03-.25-.08-3.54-1.14-4.79.29-1.07 1.21.5 2.88-.24 5.21-.7 2.18-2.59 2.35-6.1 5.21-2.89 2.36-4.69 3.82-5.1 5.89-.85 4.25 4.29 10.41 8.85 10.25 1.64-.06 2.08-.9 10.07-8.74z"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "fansi-digital_svg__cls-33",
  d: "M190.48 374.89s3.75 4.25 9.47 2.85c5.12-1.26 3.81-13.01.07-14.89-1.25-.63-3.52-.57-5.23.25-1.01.49-1.29.99-2.95 1.75-1.54.7-2.02.61-2.43 1.1-.52.62-.74 1.95.88 5.17-1.17-.83-2.42-1-3.19-.45-.12.09-.44.39-.57.79-.49 1.46 1.02 2.94 3.96 3.43z"
});

function SvgFansiDigital(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 842.55 770.55",
    className: "w-full h-full"
  }, props), _ref, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    },
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fansi-digital_svg__Layer_1"
  }, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, /*#__PURE__*/React.createElement("path", {
    d: "M475.3 333.78c14.97-4.22 19.45 2.96 31.38-2.75 14.2-6.8 24.67-24.47 26.42-41.98 2.48-24.84-13.21-43.64-24.11-56.71-25.43-30.49-57.23-38.83-66.67-41.17-12.97-3.2-70.2-15.11-117.81 28.43-34.27 31.34-42.8 72.32-45.18 84.6-3.48 17.92-14.39 74.21 13.89 94.88 16.43 12.02 42.34 9.14 58.5-2.33 11.76-8.35 9.34-13.84 20.83-21.99 22.58-16 38.09 2.51 63.83-10.12 20.13-9.87 18.29-25.06 38.92-30.87z",
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.51,
    fill: "#fff"
  }), _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, /*#__PURE__*/React.createElement("path", {
    d: "M380.43 349.47c.51.49 1.09.91 1.75 1.23 3.22 1.53 24.3 4.96 29.39 3.05a6.89 6.89 0 001.77-.98c.22-.64.34-1.32.34-2.02v-3.74l-33.26-3.46v5.93z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#fansi-digital_svg__linear-gradient-7)",
    opacity: 0.3
  }), _ref20, /*#__PURE__*/React.createElement("path", {
    d: "M412.87 342.16l-30.96-3.22c-1.22-.13-2.34.46-2.97 1.4a6.587 6.587 0 003.24 3.4c3.22 1.53 25.2 5.41 29.39 3.44 1.63-.77 2.91-2.06 3.59-3.64a3.156 3.156 0 00-2.29-1.37z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#fansi-digital_svg__linear-gradient-9)",
    opacity: 0.3
  }), _ref21, _ref22, _ref23, /*#__PURE__*/React.createElement("path", {
    d: "M410.37 326.23c0 1.74-5.96 3.15-13.31 3.15s-13.31-1.41-13.31-3.15 5.96-3.15 13.31-3.15 13.31 1.41 13.31 3.15z",
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5,
    fill: "#cad8f5"
  }), _ref24, _ref25, _ref26, /*#__PURE__*/React.createElement("path", {
    d: "M398.08 291.54c1.21-20.71 36.12-25.55 35.97-44.05-.09-11.39-13.96-19.85-16.93-21.54-21.83-12.48-48.69 1.93-54.24-8.27-1.38-2.54-.73-5.31-.36-6.88.56-2.38 1.82-4.6 3.69-6.62-15.4 9.59-25.58 26.16-25.58 44.99s9.3 33.94 23.59 43.69c6.06 4.14 9.73 10.95 9.73 18.29v4.11c0 8.93 7.24 16.17 16.17 16.17h13.86c8.93 0 16.17-7.24 16.17-16.17v-3.29c-1.91 1.46-4.1 2.48-6.5 2.46-8.34-.07-16.18-12.58-15.58-22.89z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#fansi-digital_svg__linear-gradient-16)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 397.96,
    cy: 251.25,
    rx: 48.55,
    ry: 46.82,
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.44,
    fill: "#cad8f5"
  }), _ref27, _ref28, _ref29, /*#__PURE__*/React.createElement("path", {
    d: "M624.27 439.75c-.47 8.16-2.16 16.68-5.39 24.57-2.17 5.32-14.15 34.59-41.33 37.77-16.9 1.97-34.59-6.75-46.22-22.56 3.44 3.36 6.74 5.09 9.47 6.05 9.25 3.25 15.43-1.07 28.58 3.2 9 2.92 8.79 5.82 12.56 5.34 12.35-1.54 10.11-31.96 30.19-47.82 3.95-3.12 8.13-5.18 12.13-6.55z",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15,
    fill: "url(#fansi-digital_svg__linear-gradient-17)"
  }), _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, /*#__PURE__*/React.createElement("path", {
    d: "M618.91 530.29c-.15-20.15-10.89-23-9.81-40.34 1.09-17.46 12.22-18.42 11.83-33.44-.47-18.27-17.11-24.04-16.46-40.65.22-5.6 2.34-10.54 5.11-14.72 10.42-4.91 19.96-5.9 25.48-6.04 5.32 13.13 12 32.93 15.15 57.7 2.85 22.35 1.52 37.15 0 67.86-.96 19.4-1.95 47.51-1.65 82.14-5.92 1.9-10.75 2.34-14 2.42-11.5.26-15.34-3.9-27.09-2.75-5.12.5-6.4 1.49-8.12.34-4.2-2.8-1.98-12.22.25-23.16 3.53-4.56 7.17-8.94 11.04-17.15 2.93-6.2 8.37-17.73 8.26-32.21z",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.15,
    fill: "#89d1c7"
  }), _ref38, /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    d: "M660.73 456.57c2.26-8.58 5.39-13.94 10.17-22.77 4.43-8.17 10.68-20.07 17.93-35.19 1.69-.04 3.64-.02 5.7.13 11.05 15.26 11.75 23.79 9.18 28.85-2.5 4.93-7.73 5.89-8.41 11.22-1.07 8.33 11.05 11.18 14.02 22.44 2.6 9.83-3.48 19.65-9.19 28.89-9.72 15.72-18.62 17.66-18.29 26.08.34 8.76 10.06 8.91 14.02 19.63 6.21 16.8-13.08 28.89-7.29 43.75 4.49 11.52 18.03 9.31 26.36 24.12 1.32 2.35 2.26 4.73 2.96 7.08-12.61-1.69-13.39-4.31-25.86-5.91-14.03-1.81-19.74.66-23.7-3.9-3.32-3.82-2.33-9.02-1.9-15.1.8-11.35-1.53-9.61-4.81-37.56-.68-5.76-1.46-26.08-3.01-66.5-.28-7.34-.52-15.29 2.11-25.28z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#89d1c7",
    opacity: 0.3
  })), _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, /*#__PURE__*/React.createElement("path", {
    d: "M653.04 469.66c-1.68-9.16 3.49-16.27-1.46-24.86-5.1-8.84-14.04-7.34-20.47-14.62-2.05-2.32-3.88-5.6-4.78-10.39l-2.89-.27c-1.59-.15-2.83 1.34-2.4 2.88l16.24 58.18c.25.91 1.05 1.57 1.99 1.65l22.78 2.01c-5.79-5.2-8.19-10.21-8.99-14.58z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#fansi-digital_svg__linear-gradient-18)",
    opacity: 0.3
  }), _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, /*#__PURE__*/React.createElement("path", {
    d: "M185.26 514.57c5.83.61 11.66 1.22 17.49 1.82 10.49 18.26 13.42 37.27 11.58 45.67-2.6 11.89-9.5 15.7-9.12 27.65.37 11.82 7.34 14.88 11.75 28.81 3.06 9.64 2.25 18.51.51 35.85-3.5 34.93-11.94 45.61-4.87 57.06 2.01 3.25 5.62 7.13 12.71 10.09-.17 2.14-.34 4.29-.53 6.41l-11.85-.54c-5.71-11.34-12.45-28.51-13.07-49.71-.65-22.11 6.06-25.05 5.63-46.22-.55-27.44-12.06-34.76-18.19-67.77-2.34-12.62-3.92-29.11-2.05-49.11z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#545588",
    opacity: 0.3
  }), _ref53, _ref54, _ref55, /*#__PURE__*/React.createElement("path", {
    d: "M174.64 479.3c-1.53 5.63-7.03 9.84-10.86 23.54-.83 2.96-6.72 24.02.92 29.2 4.41 2.99 8.38-2.68 19.09-3.42 18.56-1.28 27.4 14.32 39.53 10.06 2.1-.74 4.88-2.32 7.65-5.94.55 3.26.46 6.1-1.27 8.97-3.1 5.14-9.21 6.76-23.4 8.79-36.19 5.17-54.28 7.75-60.19-1.32-2.45-3.76-1.37-6.94.2-19.37 1.63-12.94 4.15-32.89 2.74-45.86-3.15-28.9-26.75-31.81-25.06-53.48.45-5.79 2.58-10.95 5.43-15.44 29.94 12.11 50.04 46.57 45.23 64.27z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#e39fb7",
    opacity: 0.3
  }), _ref56, _ref57, _ref58, _ref59, _ref60)));
}

export default SvgFansiDigital;